import { useSyncExternalStore } from "react";
import { useAuth } from "../context/AuthContext";
import { getOffice, setOffice } from "../lib/api";

export const BUMA_ROLES = ["super_admin", "role_manager"];

let snapshot = getOffice();
const subscribe = (cb) => {
  const sync = () => { snapshot = getOffice(); cb(); };
  window.addEventListener("buma:office-changed", sync);
  return () => window.removeEventListener("buma:office-changed", sync);
};
const getSnapshot = () => snapshot;
const enter = (org) => setOffice(org);
const exit = () => setOffice(null);

// BUMA staff can "enter" a BUMA-owned office and act as its admin (X-Office-Id header).
export const ORG_STAFF_ROLES = ["center_admin", "org_manager", "org_finance", "org_teacher_manager", "org_admin_officer", "trainer"];
export function useOffice() {
  const { role, caps } = useAuth();
  const isBuma = BUMA_ROLES.includes(role);
  const stored = useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
  const isFinance = role === "finance_manager" || role === "org_finance";
  const office = isBuma || role === "finance_manager" ? stored : null;
  // enterprise manager/finance/trainer-with-grants use the center-admin toolset within their capabilities
  const effectiveRole = office || ORG_STAFF_ROLES.includes(role) ? "center_admin" : role;
  const can = (cap) => cap.split("|").some((c) => caps.includes(c));
  // "wide" = sees learners of all enterprises/offices (BUMA staff or the BUMA-wide finance manager, outside an office)
  return { office, isBuma, isFinance, effectiveRole, can, caps, isSuper: isBuma && !office, isWide: (isBuma || role === "finance_manager") && !office, enter, exit };
}
